import { render } from "./collect.vue?vue&type=template&id=5a3fab50&scoped=true"
import script from "./collect.vue?vue&type=script&lang=js"
export * from "./collect.vue?vue&type=script&lang=js"

import "./collect.vue?vue&type=style&index=0&id=5a3fab50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a3fab50"]])

export default __exports__